import React from 'react';
import { Navigate } from 'react-router-dom';

const Guest = ({ Component, childrenProps={} }) => {
  
  // const verificationToken = localStorage.getItem('verificationToken'); 

  // if(verificationToken){ 
  //   return <Navigate to="/application" />;
  // }
    
  return (
    <>
      <Component {...childrenProps} />
    </>
  )
}

export default Guest
